import * as DOMPurify from "dompurify";
import React, { Component } from "react";
import { compose } from "recompose";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Table from "@material-ui/core/Table";
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";
import { withStyles } from "@material-ui/core/styles";
import _ from "lodash";
import ClonePlayerSelectDialog from "./ClonePlayerSelectDialog";
import PlayerManagementTable from "./PlayerManagementTable";
import { MuiThemeProvider } from "@material-ui/core/styles";
import Papa from "papaparse";
import aceTheme from "../../util/aceTheme";
import http from "../../util/http";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";

const debounce = (func, delay) => {
  let timeout = null;

  return (...args) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

const styles = (theme) => ({
  content: {
    paddingBottom: 5,
  },
  buttonContainer: {
    float: "right",
  },
  agencySelectLabel: {
    float: "left",
    padding: 10,
  },
  button: {
    margin: theme.spacing.unit,
  },
  toolbar: {
    alignItems: "center",
    justifyContent: "flex-end",
    ...theme.mixins.toolbar,
  },
  smallCell: { padding: 0 },
  table: {
    overflow: "visible",
    backgroundColor: "white",
    zIndex: 100,
  },
  progressLinear: {
    width: "100%",
    height: 5,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
});

function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

const getPlayerListByPagination = async () => {
  try {
    const pageSize = 1500;
    const playerListCount = await http.sendHelperCommand(
      "PlayerManagementListCountHelper.aspx",
      {}
    );
    const totalRequests = Math.ceil(playerListCount / pageSize);
    const requestArray = [];
    for (let i = 0; i < totalRequests; i++) {
      const currentPage = i + 1;
      const request = await http.sendHelperCommandPost(
        "PlayerManagementListPaginationHelper.aspx",
        { pageSize, currentPage }
      );
      requestArray.push(request);
    }
    return [].concat(...requestArray);
  } catch (err) {
    console.log(err);
  }
};
class PlayerManagement extends Component {
  state = {
    filterType: "player",
    filterText: "",
    searchError: false,
    errorMessage: "",
    searching: false,
    clonePlayerSelectOpen: false,
    agentList: [],
    playerList: [],
    initialPlayerList: [],
    selectedAgent: 1,
    playersByAgent: [],
    anchorEls: {},
    displayAgentSlider: true,
    showPassword: true,
  };
  componentDidUpdate() {
    //this is a little hack for re-printing <player> tags
    const plrCount = window.jQuery("player").length;
    if (plrCount > 0 && plrCount < 5000) {
      window.staggerPlayerInit(0, plrCount);
    }
  }
  handleChange = (event, value) => {
    this.setState({ selectedAgent: value, anchorEls: {} });
  };

  handleScroll = () => {
    const firstTable = document.getElementsByClassName(
      "player-management-table-title"
    )[0];
    if (firstTable) {
      const firstHeader = firstTable.nextSibling.firstChild;
      const isHeaderInViewPort = isElementInViewport(firstHeader);
      const stickyHeader = document.getElementById(
        "sticky-table-player-management"
      );
      if (!isHeaderInViewPort) {
        const upperElement = document.getElementsByClassName("reportHeader")[0];
        stickyHeader.style.position = "fixed";
        stickyHeader.style.display = "table";
        const isUpperInViewPort = isElementInViewport(upperElement);
        if (isUpperInViewPort) {
          stickyHeader.style.top = `${upperElement.clientHeight + 1}px`;
        } else {
          stickyHeader.style.top = `0px`;
        }
        stickyHeader.innerHTML = firstHeader.outerHTML;
        stickyHeader.style.width = `${firstHeader.clientWidth}px`;
        stickyHeader.style.marginLeft = "5px";
        const stickyChildNodes = stickyHeader.firstChild.firstChild.childNodes;
        const parentTableChildNodes =
          firstTable.nextSibling.childNodes[1].firstChild.childNodes;

        stickyChildNodes[0].style.width = `${parentTableChildNodes[0].offsetWidth}px`;
        stickyChildNodes[1].style.width = `${parentTableChildNodes[1].offsetWidth}px`;
        stickyChildNodes[2].style.width = `${parentTableChildNodes[2].offsetWidth}px`;
        stickyChildNodes[3].style.width = `${parentTableChildNodes[3].offsetWidth}px`;
        stickyChildNodes[4].style.width = `${parentTableChildNodes[4].offsetWidth}px`;
        stickyChildNodes[5].style.width = `${parentTableChildNodes[5].offsetWidth}px`;
        stickyChildNodes[6].style.width = `${parentTableChildNodes[6].offsetWidth}px`;
        stickyChildNodes[7].style.width = `${parentTableChildNodes[7].offsetWidth}px`;
        stickyChildNodes[8].style.width = `${parentTableChildNodes[8].offsetWidth}px`;
        stickyChildNodes[9].style.width = `${parentTableChildNodes[9].offsetWidth}px`;
        stickyChildNodes[10].style.width = `${parentTableChildNodes[10].offsetWidth}px`;
      } else {
        stickyHeader.style.display = "none";
      }
    }
  };
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  formatPlayerList = (playerList) => {
    const playersByAgent = _.groupBy(playerList, "IdAgent");
    const agentList = _.chain(playerList)
      .map((i) => _.pick(i, "IdAgent", "Agent"))
      .uniqBy("IdAgent")
      .orderBy("Agent")
      .value();
    agentList.unshift({
      IdAgent: -1,
      Agent: "All",
    });
    this.setState({
      searching: false,
      agentList,
      playerList,
      playersByAgent,
      displayAgentSlider: agentList.length > 2,
    });
  };
  debouncedFetchSuggestions = debounce(this.formatPlayerList, 350);
  handleFilterChange = (value, ev) => {
    this.setState({
      filterType: value,
      filterText: "",
    });
    const filterText = document.getElementById("player-mgmt-filter-text");
    filterText.value = "";
    this.debouncedFetchSuggestions(_.clone(this.state.initialPlayerList));
  };
  handleFilterText = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    const filterText = DOMPurify.sanitize(ev.target.value).toUpperCase();
    this.setState({
      filterText,
    });
    if (filterText.length > 0) {
      if (this.state.filterType === "agent") {
        const filteredPlayerList = _.filter(
          this.state.initialPlayerList,
          (player) => {
            return player.Agent.toUpperCase().indexOf(filterText) !== -1;
          }
        );
        this.debouncedFetchSuggestions(filteredPlayerList);
      } else {
        const filteredPlayerList = _.filter(
          this.state.initialPlayerList,
          (player) => {
            return (
              player.Name.toUpperCase().indexOf(filterText) !== -1 ||
              player.Player.toUpperCase().indexOf(filterText) !== -1
            );
          }
        );
        this.debouncedFetchSuggestions(filteredPlayerList);
      }
    } else {
      this.debouncedFetchSuggestions(_.clone(this.state.initialPlayerList));
    }
    this.setState({ selectedAgent: 0, anchorEls: {} });
  };
  async componentDidMount() {
    try {
      const stickyPlayerManagement = document.getElementById(
        "sticky-table-player-management"
      );
      if (stickyPlayerManagement) {
        stickyPlayerManagement.style.display = "none";
        window.addEventListener("scroll", this.handleScroll);
      }
      this.setState({ searching: true });
      const playerList = await getPlayerListByPagination();
      this.setState({
        initialPlayerList: playerList,
      });
      this.formatPlayerList(playerList);
    } catch (err) {
      this.setState({
        searchError: true,
        errorMessage: err.message,
        searching: false,
      });
    }
  }
  handleClick = (idPlayer) => (event) => {
    const currentAnchorEls = this.state.anchorEls;
    currentAnchorEls[idPlayer] = event.currentTarget;
    this.setState({ anchorEls: currentAnchorEls });
  };
  handleClose = (idPlayer) => () => {
    const currentAnchorEls = this.state.anchorEls;
    currentAnchorEls[idPlayer] = null;
    this.setState({ anchorEls: currentAnchorEls });
  };
  handleClonePlayerSelectDialogClose = () => {
    this.setState({ clonePlayerSelectOpen: false });
  };
  selectPlayerCloneDialog = (player) => {
    this.props.menuClick("clone", player)();
    this.setState({ clonePlayerSelectOpen: false });
  };
  onNewPlayer = () => {
    this.setState({ clonePlayerSelectOpen: true });
  };
  onPasswordClick = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };
  downloadCSV = (selectedAgent, playersToDisplay) => {
    const objToProcess =
      selectedAgent === 0
        ? _.flatMap(playersToDisplay, "list")
        : playersToDisplay[0].list;
    const fileName = selectedAgent === 0 ? "ALL" : playersToDisplay[0].agent;

    const csv = Papa.unparse(objToProcess);
    const data = new Blob([csv], { type: "text/csv" });
    const csvURL = window.URL.createObjectURL(data);
    const tempLink = document.createElement("a");

    tempLink.href = csvURL;
    tempLink.setAttribute("download", `${fileName}.csv`);
    tempLink.click();
  };
  render() {
    const {
      classes,
      menuClick,
      isDistributor,
      onNewOnlineMessage,
      createPlayerPriv,
    } = this.props;
    const {
      searching,
      agentList,
      anchorEls,
      playerList,
      filterType,
      filterText,
      searchError,
      errorMessage,
      selectedAgent,
      playersByAgent,
      displayAgentSlider,
      clonePlayerSelectOpen,
      showPassword,
    } = this.state;

    const currentAgent = _.get(agentList[selectedAgent], "Agent", "");
    const selectedAgentId = _.get(agentList[selectedAgent], "IdAgent", -1);
    const playersSelectedAgent = _.get(playersByAgent, selectedAgentId, []);
    let playersToDisplay = [];
    if (selectedAgentId === -1) {
      _.each(agentList, (agentData, i) => {
        if (i !== 0) {
          const currentAgentAll = agentData.Agent;
          const selectedAgentId = agentData.IdAgent;
          const playersSelectedAgentAll = _.get(
            playersByAgent,
            selectedAgentId,
            []
          );
          playersToDisplay.push({
            agent: currentAgentAll,
            list: playersSelectedAgentAll,
          });
        }
      });
    } else {
      playersToDisplay.push({
        agent: currentAgent,
        list: playersSelectedAgent,
      });
    }
    return (
      <MuiThemeProvider theme={aceTheme}>
        <ClonePlayerSelectDialog
          selectPlayer={this.selectPlayerCloneDialog}
          playerList={playerList}
          open={clonePlayerSelectOpen}
          menuClick={menuClick}
          handleClose={this.handleClonePlayerSelectDialogClose}
        />
        {!searching && searchError && (
          <Paper>
            <Typography>Whoops, Something happened: {errorMessage}</Typography>
          </Paper>
        )}
        {searching && !searchError && (
          <Paper>
            <LinearProgress className={classes.progressLinear} />
          </Paper>
        )}
        {!searching && !searchError && (
          <div className={classes.content}>
            {displayAgentSlider && (
              <Typography
                className={classes.agencySelectLabel}
                variant="headline"
              >
                Select an agency to view the players:
              </Typography>
            )}
            <div className={classes.buttonContainer}>
              <FormControl component="fieldset">
                <FormLabel>Search Type</FormLabel>
                <RadioGroup
                  row
                  name="type"
                  aria-label="type"
                  value={filterType}
                  onChange={(ev, value) => {
                    this.handleFilterChange(value, ev);
                  }}
                >
                  {isDistributor === "True" && (
                    <FormControlLabel
                      value="agent"
                      control={<Radio />}
                      label="Agent"
                    />
                  )}
                  <FormControlLabel
                    value="player"
                    control={<Radio />}
                    label="Player"
                  />
                </RadioGroup>
              </FormControl>
              <input
                id="player-mgmt-filter-text"
                type="text"
                style={{ fontSize: 20, lineHeight: "32px", marginTop: 16 }}
                onChange={this.handleFilterText}
              />
              {createPlayerPriv && (
                <Button
                  variant="contained"
                  onClick={this.onNewPlayer}
                  className={classes.button}
                >
                  Add Player
                </Button>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={onNewOnlineMessage}
                className={classes.button}
              >
                New Online Message
              </Button>
            </div>
            {displayAgentSlider && (
              <AppBar position="static" color="default">
                <Tabs
                  value={selectedAgent}
                  onChange={this.handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollable
                  scrollButtons="auto"
                >
                  {_.map(agentList, (agent) => (
                    <Tab
                      key={`tab-player-management-agent-${agent.IdAgent}`}
                      label={agent.Agent}
                    />
                  ))}
                </Tabs>
              </AppBar>
            )}
            <Table
              id="sticky-table-player-management"
              className={classes.table}
            />
            {playersToDisplay.map((playerData) => (
              <PlayerManagementTable
                key={`player-management-table-${playerData.agent}`}
                {...{
                  anchorEls,
                  menuClick,
                  createPlayerPriv,
                  handleClose: this.handleClose,
                  playerData,
                  showPassword,
                  onPasswordClick: this.onPasswordClick,
                  handleClick: this.handleClick,
                }}
              />
            ))}
          </div>
        )}
      </MuiThemeProvider>
    );
  }
}

PlayerManagement.propTypes = {
  theme: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  menuClick: PropTypes.func.isRequired,
  onNewOnlineMessage: PropTypes.func.isRequired,
  createPlayerPriv: PropTypes.bool.isRequired,
};

export default compose(
  withStyles(styles, {
    name: "PlayerManagement",
    withTheme: true,
  })
)(PlayerManagement);
